import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-multi-icon-button-template',
    templateUrl: './multi-icon-button-template.component.html',
    styleUrls: ['./multi-icon-button-template.component.scss']
})
export class MultiIconButtonTemplateComponent {
    @Input() beforeIcons: string[];
    @Input() afterIcons: string[];
    @Input() templateName = 'multiIconTemplate';

    getBeforeIcons(data): string[] {
        const allIcons = JSON.parse(data.text);
        if (allIcons && allIcons.beforeIcons) {
            return allIcons.beforeIcons;
        } else {
            return [];
        }
    }

    getAfterIcons(data): string[] {
        const allIcons = JSON.parse(data.text);
        if (allIcons && allIcons.afterIcons) {
            return allIcons.afterIcons;
        } else {
            return [];
        }
    }

    getLabel(data): string {
        const label = JSON.parse(data.text);
        return label.label;
    }
}
